module.exports = __webpack_public_path__ + "static/media/bug.a4c9f1f9.png";